const React = require('react');
const css = require('./module.scss');

class Switch extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: props.checked
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            checked: nextProps.checked
        });
    }

    onClick(e) {
        if (this.props.disabled) {
            return;
        }
        let checked = !!this.refs.checkbox.checked;
        this.props.onClick && this.props.onClick(checked, e);
    }

    render() {
        let cls = ['fp-switch-item'];
        if (this.state.checked) {
            cls.push('fp-switch-on');
        } else {
            cls.push('fp-switch-off');
        }

        return <label className="fp-swtich-wrap" for="switch-item">
            <input type="checkbox" id="switch-item"
                ref="checkbox"
                checked={!!this.state.checked}
                name={this.props.name}
                disabled={this.props.disabled}
                readonly={this.props.readonly}
                onClick={this.onClick.bind(this)}/>
            <span className={cls.join(' ')}>{this.state.checked ? 'ON' : 'OFF'}</span>
        </label>;
    }
}

module.exports = Switch;



// WEBPACK FOOTER //
// ./component/switch/index.js